import { createAsyncThunk } from "@reduxjs/toolkit";
import { study } from "../../../API/UserManagement/Study";
const getstudies = createAsyncThunk(
  "study/getAllStudy",
  async () => {
    try {
      const data = await study.getAll();
      return data;
    } catch (err) {
      console.log("error");
      ;
    }
  }
);

export { getstudies };
